import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface ChevronUpDownIconProps extends IconWrapperProps {
  color?: string;
}

const ChevronUpDownIcon = ({ color = 'currentColor', ...props }: ChevronUpDownIconProps) => (
  <IconWrapper viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7 10l5-5 5 5M7 14l5 5 5-5"
    />
  </IconWrapper>
);

export default ChevronUpDownIcon;
